
import {Options, Vue} from 'vue-class-component';
import NotusSvgIcon from '@/app/modules/shared/components/svg-icon/svg-icon.component.vue';
import {GetterTypes} from '@/store/modules/FormModule/getters/getter-types';
import {namespace} from 'vuex-class';

const formModule = namespace('form');

@Options({
  components: {NotusSvgIcon},
})
export default class ThankYouComponent extends Vue {
  @formModule.Getter(GetterTypes.proposalId) proposalId?: string;
}
